import React, { useState } from "react";
import { useForm, useStep } from "react-hooks-helper";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { number, size } from "mathjs";
import { Steps, Button, message, Form, Card } from "antd";
import First from "./first";
import Second from "./second";
import Third from "./third";
import Fourth from "./fourth";
import Final from "./final";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

const steps = [
  { id: "first" },
  { id: "second" },
  { id: "third" },
  { id: "fourth" },
  { id: "final" },
];

const defaultData = {
  display_name: null,
  email: null,
  name: null,
  panNumber: null,
  phone: null,
  address: null,
  slug: null,
  website: null,
  promoCode: null,
  features: [],
};

const extraData = {
  accounting_start_date: null,
  vat_registered: true,
  logo: null,
  showMoreInfo: false,
  showPromoCode: false,
  termsAccepted: false,
  logoFile: null,
  logoError: "",
  logoUploading: false,
  uploadedLogoId: null,
  namespace_features: {
    track_inventory: false,
    manufacturing_enabled: false,
    pos_enabled: false,
    location_enabled: false,
    warehouse_enabled: false,
    multi_currency_enabled: false,
    pos_retail_enabled: false,
    pos_restaurant_enabled: false,
  },
};

const NewCompanyPage = ({ domains, authenticator, ...props }) => {
  const [formData, setForm] = useForm(defaultData);
  console.log({ formData });
  const [extra, setExtra] = useState(extraData);
  const [regId, setRegId] = useState("");
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const dataProps = { formData, setForm, extra, setExtra, navigation, domains, authenticator };
  const extraDataProps = {
    formData,
    setForm,
    extra,
    setExtra,
    navigation,
    setRegId,
    domains,
    authenticator,
  };
  const finalProps = { regId, props };
  const history = useHistory();

  return (
    <div style={{ width: "100%" }}>
      {(() => {
        switch (id) {
          case "first":
            return <First {...dataProps} />;
          case "second":
            return <Second {...dataProps} />;
          case "third":
            return <Third {...extraDataProps} />;
          case "fourth":
            return <Fourth {...extraDataProps} />;
          case "final":
            return <Final {...finalProps} />;
          default:
            break;
        }
      })()}
    </div>
    /* <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Card style={{ width: "60%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <div>
            <p className="form-header-verify">Sign in to Tigg</p>
            <p style={{ fontSize: 12, color: "#636972" }}>me.tiggapp.com</p>
          </div>
          <img
            src="images/tigg_logo.png"
            className="form-logo"
            alt="form-logo"
            style={{ margin: 0 }}
          />
        </div>
        <div style={{ width: "100%" }}>
          {(() => {
            switch (id) {
              case "first":
                return <First {...dataProps} />;
              case "second":
                return <Second {...dataProps} />;
              case "third":
                return <Third {...thirdProps} />;
              case "fourth":
                return <Fourth {...thirdProps} />;
              case "final":
                return <Final {...finalProps} />;
              default:
                break;
            }
          })()}
        </div>
      </Card>
    </div> */
  );
};

export default withDomains(NewCompanyPage, "register", "fileUpload");
